import { InsightsTimeframes } from '@griply/types';
import React from 'react';
import { InsightsTimeframeSelection } from 'shared/components/ui/insights-timeframe-selection';
import { TimeframeNavigationButtons } from 'shared/components/ui/timeframe-navigation-buttons';
import { useInsightsTimeframe } from 'shared/contexts/insights-timeframe';

import * as Styled from './period-selection.style';

const TIMEFRAMES: InsightsTimeframes[] = [
  InsightsTimeframes.Week,
  InsightsTimeframes.Month,
  InsightsTimeframes.Quarter,
  InsightsTimeframes.Year,
];

export type PeriodSelectionProps = {
  isFullWidth?: boolean;
};

export const PeriodSelection: React.FC<PeriodSelectionProps> = ({
  isFullWidth,
}) => {
  const { timeframe, setTimeframe, onPrev, onToday, onNext, isNextDisabled } =
    useInsightsTimeframe();

  return (
    <Styled.Container>
      <InsightsTimeframeSelection
        value={timeframe}
        onChange={setTimeframe}
        isFullWidth={isFullWidth}
        preventDrag
        timeframes={TIMEFRAMES}
      />
      <TimeframeNavigationButtons
        onPrev={onPrev}
        onToday={onToday}
        onNext={onNext}
        isNextDisabled={isNextDisabled}
      />
    </Styled.Container>
  );
};
